// KEEP IN SYNC with functions/helpTypes.js (separate npm package, CommonJS copy)

export const MILUIM_CATEGORY = 'מילואים וקבע'

// Old category name kept for backward compatibility (mirrors CATEGORY_ALIASES in functions/index.js)
export const MILUIM_CATEGORY_ALIASES = ['מילואים וקבע', 'מילואימניקים']

export const MILUIM_COORDINATOR_FIELD = 'רכזת משפחות מילואים'

export const HELP_TYPES = [
    { id: 'trash', label: 'פינוי פח', points: 2, perHour: false },
    { id: 'luggage', label: 'עזרה בפריקת מזוודות', points: 5, perHour: false },
    { id: 'babysit', label: 'בייביסיטר - בתשלום', points: 1, perHour: true },
    { id: 'cleaning', label: 'עזרה בניקוי הבית - בתשלום', points: 2, perHour: true },
    { id: 'other', label: 'אחר', points: null, perHour: false }
]

export const isMiluimCategory = (category) => MILUIM_CATEGORY_ALIASES.includes(category)

export const getHelpType = (id) => HELP_TYPES.find(ht => ht.id === id) || null

export const helpTypeDisplayLabel = (ht) => {
    if (ht.id === 'other') {
        return `${ht.label} (הרכז יקבע ידנית את הניקוד)`
    }
    if (ht.perHour) {
        return ht.points === 1
            ? `${ht.label} (נקודה 1 לכל שעה)`
            : `${ht.label} (${ht.points} נקודות לכל שעה)`
    }
    return `${ht.label} (${ht.points} נקודות)`
}

// Fixed types → their value; hourly types → points * hours (null when hours missing); 'other' → null
export const computeSuggestedPoints = (helpTypeId, hours) => {
    const ht = getHelpType(helpTypeId)
    if (!ht || ht.points === null) return null
    if (ht.perHour) {
        const h = Number(hours)
        if (!h || h <= 0) return null
        return Math.round(ht.points * h)
    }
    return ht.points
}
